import { Tag } from "primereact/tag";
import { MedicalStaffStatus } from "../constants";

/**
 * Etiqueta que muestra el status de un caso médico
 * @param {object} props
 * @param {string} props.value
 */
export default function MedicalStaffStatusTag({ value, className }) {
  return (
    <Tag
      className={className}
      value={MedicalStaffStatus.getLabel(value)}
      style={{ backgroundColor: MedicalStaffStatus.getColor(value) }}
    />
  );
}
